import { format } from 'date-fns';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Change } from '../../../../../../../types/Form';
import useFlowInputComponent from '../../../../hooks/useFlowsInputComponent';
import { FlowsQuestion } from '../../../../types/FlowsTypes';
import DateInput from './DateInput';

interface Props {
  question: FlowsQuestion;
}

const DateInputComponent: React.FC<React.PropsWithChildren<Props>> = ({
  question,
}) => {
  const [initialValue, setInitialValue] = useState();
  const {
    field: { value, onBlur, onChange },
    error,
    prefilled,
  } = useFlowInputComponent({
    question,
  });

  const handleOnBlur = (value: string | undefined) => {
    onBlur({
      name: question.id,
      value: value ? format(new Date(value), 'yyyy-MM-dd') : value,
    });
  };

  useEffect(() => {
    /** This is needed to fix prefill for first render */
    if (!!value && !initialValue) {
      setInitialValue(value);
    }
  }, [value]);

  // Temporary fix for prefilling first registration
  if (
    question.id === 'mobility.car_registration_first' ||
    question.id === 'mobility.van_registration_first'
  )
    return (
      <StyledDateInput
        name={question.id}
        onChange={onChange}
        onBlur={(change: Change) => handleOnBlur(change.value as string)}
        error={error?.message}
        value={value}
        prefilled={prefilled}
        disabled={question.rules.is_disabled}
        dataTestId="ProdFac_DateInputComponent"
        data-test-id="ProdFac_DateInputComponent"
      />
    );

  return (
    <StyledDateInput
      key={initialValue}
      name={question.id}
      onChange={onChange}
      onBlur={(change: Change) => handleOnBlur(change.value as string)}
      error={error?.message}
      initialValue={value}
      prefilled={prefilled}
      disabled={question.rules.is_disabled}
      dataTestId="ProdFac_DateInputComponent"
      data-test-id="ProdFac_DateInputComponent"
    />
  );
};

const StyledDateInput = styled(DateInput)`
  height: auto;
  min-height: 44px;
  margin-bottom: 0;
  opacity: ${({ disabled }) => (disabled ? '0.3' : '1')};

  > label > div {
    ${({ prefilled }) =>
      prefilled
        ? `border-color: #FFBC0F; background-color: #FFF9EA;`
        : `border-color: #dbdde1; background-color: white;`}
  }
`;

export default DateInputComponent;
